module.exports = __webpack_public_path__ + "img/old.0dc3e7b7.png";